import { __extends, __assign } from 'tslib';
import { sendCommand } from '@lst/web2clientapi/core/command';
import React__default from 'react';
import Alert from 'react-s-alert';
import styles from './NotificationManager.module.scss.js';
import NotificationTemplate from './NotificationTemplate.js';

var MESSAGE_TIMEOUT = 1000 * 4;
var NotificationManager = (function (_super) {
    __extends(NotificationManager, _super);
    function NotificationManager() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.styles = styles;
        return _this;
    }
    NotificationManager.prototype.render = function () {
        return (React__default.createElement(Alert, { key: 'AlertProvider', html: true, stack: { limit: 5, spacing: 10 }, contentTemplate: NotificationTemplate, timeout: MESSAGE_TIMEOUT, position: 'bottom-right', effect: 'stackslide', offset: 20 }));
    };
    NotificationManager.sendWebNotification = function (params) {
        Alert.info('', {
            customFields: params,
            position: 'bottom-right',
            effect: 'stackslide',
            html: true,
        });
    };
    NotificationManager.sendNotification = function (params) {
        var messageParams = __assign({}, params);
        if (params.cost) {
            messageParams.currency = messageParams.currency || 'gold';
        }
        if ((window === null || window === void 0 ? void 0 : window.jsHostQuery) && typeof window.jsHostQuery === 'function') {
            sendCommand({
                command: 'notification',
                params: params,
            });
        }
        else {
            NotificationManager.sendWebNotification(params);
        }
    };
    return NotificationManager;
}(React__default.PureComponent));

export { NotificationManager as default };
//# sourceMappingURL=NotificationManager.js.map
